import { continents, countries, type TCountryCode } from "countries-list";
import { graphql, useStaticQuery } from "gatsby";
import { isValidCountryCode } from "../utils/country";

type SiteListItem = {
	domain: string;
	isSameSite: boolean;
	countryIso: TCountryCode;
	language: string;
	countryName: string;
	continent: string;
};

const query = graphql`
	query SiteConfigsSiteList {
		allParsedSiteConfig {
			nodes {
				name
				countries
				language
				store
			}
		}
	}
`;

export const useSiteList = (): SiteListItem[] => {
	const {
		allParsedSiteConfig: { nodes: sites },
	} = useStaticQuery<Queries.SiteConfigsSiteListQuery>(query);

	const siteListItems: SiteListItem[] = [];

	for (const site of sites) {
		if (!site.countries) continue;
		for (const country of site.countries) {
			const isSameSite =
				site.store === process.env.GATSBY_STORE &&
				site.language === process.env.GATSBY_LANGUAGE;

			if (
				!site.name ||
				!site.language ||
				!site.store ||
				!isValidCountryCode(country)
			)
				continue;

			const continentCode = countries[country].continent;
			const continent = continents[continentCode];

			siteListItems.push({
				domain: site.name,
				isSameSite,
				countryIso: country,
				language: site.language,
				countryName: countries[country].name,
				continent,
			});
		}
	}

	// This site is not hosted on netlify so we just add it manually for now.
	siteListItems.push({
		isSameSite: false,
		domain: "www.babybjorn.jp",
		countryIso: "JP",
		language: "JA",
		countryName: countries["JP"].name,
		continent: continents["AS"],
	});

	siteListItems.sort((a, b) => {
		if (a.countryName < b.countryName) return -1;
		if (a.countryName > b.countryName) return 1;
		return 0;
	});

	return siteListItems;
};
